import React from 'react';
import styles from './StatusBadge.module.css';

interface StatusBadgeProps {
  status: 'Paid' | 'Overdue' | 'Pending' | 'Draft';
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const badgeClass = `${styles.badge} ${styles[status.toLowerCase()]}`;

  return (
    <span className={badgeClass}>
      {status.toUpperCase()}
    </span>
  );
};

export default StatusBadge;
